import { ReactElement } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import ErrorPageType from '../../../constants/ErrorPageType';
import Meta from '../../core/components/Meta/Meta';
import Error500 from './500/500';
import NotSupported from './NotSupported';

export type ErrorPageProps = Partial<FallbackProps>;

const ErrorPage = (_: ErrorPageProps): ReactElement | null => {
  const { t } = useTranslation();
  const location = useLocation();
  const { type } = useParams<{ type?: string }>();
  const { from } = location.state || { from: { pathname: '/' } };

  return (
    <>
      <Meta title={t('error.metaTitle')} noTrack />
      {type === ErrorPageType.NOT_SUPPORTED ? <NotSupported redirectUrl={from} /> : <Error500 />}
    </>
  );
};

export default ErrorPage;
